module.exports = __webpack_public_path__ + "static/img/role.646f1ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/tsz/role.png
// module id = E5Qy
// module chunks = 7